import { CHANGE_LOGO,CHANGE_TITLE } from "./types";

export const changeImage = (image = "") => ({
    type: CHANGE_LOGO,
    payload: image,
  });
  export const changeTitle = (title = "") => ({
    type: CHANGE_TITLE,
    payload: title,
  });